import { createApp } from "vue";
import App from './App';

import reset from './styles/reset.scss';
import styles from './styles/style.scss';

createApp(App)
.mount('#app');